import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { UtilService } from '../shared/util.service';

@Pipe({
  name: 'faMoney',
})
export class FaMoneyPipe implements PipeTransform {
  constructor(utilService: UtilService) {}

  transform(input: any): any {
    if (input) {
      const dontTrim = false;

      input = dontTrim ? input.toString() : input.toString().trim();
      // add comma
      input = input.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      let i = 0;
      const len = input.length;
      let res = '';
      let pos;
      const persianNumbers: string[] = [
        '۰',
        '۱',
        '۲',
        '۳',
        '۴',
        '۵',
        '۶',
        '۷',
        '۸',
        '۹',
      ];

      for (; i < len; i++) {
        if ((pos = persianNumbers[input.charAt(i)])) {
          res += pos;
        } else {
          res += input.charAt(i);
        }
      }
      return res;
    } else {
      return 0;
    }
  }
}
